// extracted by mini-css-extract-plugin
export default {"share-url":"ShareUrlModal_share-url__0BtpA","share-url__title":"ShareUrlModal_share-url__title__wA9Dp"};